<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  aria-labelledby="reject-purchase"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <div class="p-modal-head01">
      <h1
        class="p-modal-head01__title"
        id="reject-purchase"
        [innerHTML]="'label.rejectPurchaseRequest' | staticMsg"
      ></h1>

      <button
        id="close-reject-purchase-button"
        class="p-modal-head01__close js-modal-close"
        (click)="this.close()"
      ></button>
    </div>
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <div class="textarea-container">
      <label class="reject-label">
        <span [innerHTML]="'label.reasonForReturn' | staticMsg"></span>
      </label>
      <textarea id="reject" class="reject-comment" [(ngModel)]="rejectComment"></textarea>
    </div>
    <div class="button-container">
      <asw-button id="reject-purchase-confirm-button" size="s" (click$)="rejectPurchase()">
        <span [innerHTML]="'label.sendBack' | staticMsg"></span>
      </asw-button>
    </div>
  </div>

  <div #modalFooter [class]="lmodalFooterClass"></div>
</div>
